import React, { useEffect, useRef } from 'react'
import './aboutusworking.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Working = () => {
    const textRef = useRef(null);
    const paraRef = useRef(null);
    const buttonRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: textRef.current,
                start: "top 80%",
                toggleActions: "play none none none",
            },
        });

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);

    useEffect(() => {
        gsap.fromTo(
            paraRef.current,
            { opacity: 0, y: 50 },
            {
                opacity: 1,
                y: 0,
                duration: 1,
                ease: "power2.out",
                scrollTrigger: {
                    trigger: paraRef.current,
                    start: "top 90%",
                    toggleActions: "play none none none",
                },
            }
        );
    }, []);

    useEffect(() => {
        const tl = gsap.timeline({
            scrollTrigger: {
                trigger: buttonRef.current,
                start: "top 85%",
                toggleActions: "play none none none",
            },
        });

        gsap.set(buttonRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(buttonRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 0.5,
            ease: "power2.out",
        }).to(buttonRef.current, {
            rotateY: 360,
            duration: 0.8,
            ease: "power2.inOut",
        });
    }, []);

    return (
        <>
            <section className='workingmainprntaboutus'>
                <div className="aboutusimgposition">
                    <img className='img-fluid' src="\assets\Aboutus\postionourmission.png" alt="Our Mission bg  img" />
                </div>
                <div className="custom-container">
                    <div className="workingmainchld">
                        <div className="imgleftworking displaynoneonmobile">
                            <img className='img-fluid' src="\assets\Aboutus\aboutusourimgmission.png" alt="Our Mission" />
                        </div>
                        <div className="imgleftworking d-none displayshowonmobile">
                            <img className='img-fluid d-block m-auto' src="\assets\Aboutus\aboutusourimgmissionmbl.png" alt="Our Mission" />
                        </div>

                        <div className="aboutusmission">
                            {/* <h5 ref={buttonRef}>Mission</h5> */}
                            <div className="aboutusmissioncnt">
                                <h2 ref={textRef}>Our Mission</h2>
                                <p ref={paraRef}>To provide a unified ecosystem that champions freedom of expression, privacy, and seamless connectivity—bridging the gap between decentralized technologies and real-world applications.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Working